<template>
    <div class="person-edit">
        <Header :app="app" :left="true" :title="selectedPerson.name">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.go(-1)">
                    &laquo;
                </a>
            </template>
        </Header>

        <div class="content">
            <div class="field">
                <label>Person Name</label>
                <input type="text" v-model="selectedPerson.name" v-on:blur="app.save(selectedPerson, 'name')" autofocus>
            </div>

            <div class="field">
                <button v-on:click="app.remove(app.people, selectedPerson, 'person', false, true)" class="full-width button-small button-gray">
                    Delete This Person
                </button>
            </div>

            <!-- <pre>
                How often does this person meet?
                Repeats weekly [choose days]
                Repeats monthly [choose dates]
            </pre> -->
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'personEdit',
    components: {
        Header
    },
    props: ['app'],
    computed: {
        selectedPerson() {
          var _ = this;

          return _.app.people.find(function(person) {
              return person.id + '' === _.$route.params.id + '';
          });
        },
    }
};
</script>
